import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { parseJwt } from '../../components/utilities/utils';
import { BASE_URLS } from "../../constants/constants";
let userDetails = localStorage.getItem("access_token")
  ? parseJwt(localStorage.getItem("access_token"))
  : {};

let { authorizedDistricts, authorizedStates, authorizedAcs } = userDetails;
export const newstateApi = createApi({
  reducerPath: 'newstateApi',
  baseQuery: fetchBaseQuery({ baseUrl: BASE_URLS.CONTROLTABLEMANAGEMENT_BASE_URL,
    prepareHeaders: (headers) => {
      headers.set("authorization", `Bearer ${localStorage.access_token}`);
      headers.set("currentRole", localStorage.userrole);
      if(localStorage.userrole!=="eci"){
      headers.set("state",authorizedStates?.[0]);
      }
      return headers;
    },
   }),
 
  endpoints: (builder) => ({
    getAllStates: builder.query({
      query: (states) => (
        {
          url: `/api/v1/controlTable/getAllStates`,
          method: 'GET',
          headers: {
            'Content-type': 'application/json; charset=UTF-8',
          }
        })
    }),
    getStateCode: builder.query({
      query: (statetype) => (
        {
          url: `api/v1/controlTable/getStateCd?stateType=${statetype}`,
          responseHandler:(response) => response.text(),
          method: 'GET',
          headers: {
            'Content-type': 'application/json; charset=UTF-8',
          }
        })
    }),
    getAcbasedonStatecode: builder.query({
      query: (stateCd) => (
        {
          url: `/api/v1/controlTable/getListOfAcBasedOnStateCd?stateCd=${stateCd}`,
          method: 'GET',
          headers: {
            'Content-type': 'application/json; charset=UTF-8',
          }
        }),
      transformResponse: (response, meta, arg) => {
        localStorage.setItem(`totalac${arg}`, response.length);
        return response;
      },
    }),
    getDistrictbasedonStatecode: builder.query({
      query: (stateCd) => (
        {
          url: `/api/v1/controlTable/getListOfDistrictsBasedOnStateCd?stateCd=${stateCd}`,
          method: 'GET',
          headers: {
            'Content-type': 'application/json; charset=UTF-8',
          }
        }),
      transformResponse: (response, meta, arg) => {
        localStorage.setItem(`totaldis${arg}`, response.length);
        return response;
      },
    }),
    getPartbasedonAcNo: builder.query({
      query: (acNo) => (
        {
          url: `/api/v1/controlTable/getPartsbyAcNumber?acNumber=${acNo}`,
          method: 'GET',
          headers: {
            'Content-type': 'application/json; charset=UTF-8',
          },
        }),
      transformResponse: (response, meta, arg) => {
        localStorage.setItem(`assemblyNO${arg}`, response.length)
        return response;
      },
    }),
    getPCbasedonStateCode: builder.query({
      query: (stateCd) => (
        {
          url: `/api/v1/controlTable/getListOfPcBasedOnStateCd?stateCd=${stateCd}`,
          method: 'GET',
          headers: {
            'Content-type': 'application/json; charset=UTF-8',
          }
        }),
      transformResponse: (response, meta, arg) => {
        localStorage.setItem(`totalpc${arg}`, response.length);
        return response;
      },
    }),
    getAcbasedonPcNo: builder.query({
      query: (pcNo) => (
        {
          url: `/api/v1/controlTable/getAcsbypcNo?pcNo=${pcNo}`,
          method: 'GET',
          headers: {
            'Content-type': 'application/json; charset=UTF-8',
          },
        }),
      transformResponse: (response, meta, arg) => {
        localStorage.setItem(`PcNO${arg}`, response.length)
        return response;
      },
    }),
    getAcbasedonDistrictCode: builder.query({
      query: (districtCd) => (
        {
          url: `/api/v1/controlTable/getAcsbyDistrictCd?DistrictCd=${districtCd}`,
          method: 'GET',
          headers: {
            'Content-type': 'application/json; charset=UTF-8',
          },
        }),
      transformResponse: (response, meta, arg) => {
        localStorage.setItem(`districtCd${arg}`, response.length)
        return response;
      },
    }),
    createnewstate: builder.mutation({
      query: (newstate) => {
        return {
          url: "/api/v1/controlTable/addNewState",
          method: 'POST',
          body: newstate,
          headers: {
            'Content-type': 'application/json',
            'wcConfigId': 7001,
          }
        }
      },
    }),
    splitState: builder.mutation({
      query: (statedata) => {
        return {
          url: `/api/v1/controlTable/splitStateRequest`,
          method: 'POST',
          body: statedata,
          headers: {
            'Content-type': 'application/json',
            'wcConfigId': 7003,
          }
        }
      },
    }),
    mapDistrictsForState: builder.mutation({
      query: (data) => {
        const { ctId, bodydata } = data
        return {
          url: `/api/v1/controlTable/mapDistrictsforState?ctId=${ctId}`,
          method: 'POST',
          body: bodydata,
          headers: {
            'Content-type': 'application/json',
            'wcConfigId': 7005,
          }
        }
      },
    }),
    demapDistrictsForState: builder.mutation({
      query: (data) => {
        const { ctId, bodydata } = data
        return {
          url: `/api/v1/controlTable/deMapDistrictsForState?ctId=${ctId}`,
          method: 'POST',
          body: bodydata,
          headers: {
            'Content-type': 'application/json',
            'wcConfigId': 7009,
          }
        }
      },
    }),
    mergeState: builder.mutation({
      query: (mergedata) => {
        return {
          url: `/api/v1/controlTable/mergeState`,
          method: 'POST',
          body: mergedata,
          headers: {
            'Content-type': 'application/json',
            'wcConfigId': 7007,
          }
        }
      },
    }),
    editDistrict: builder.mutation({
      query: (mergedata) => {
        return {
          url: `/api/v1/controlTable/updateDistrictDetails`,
          method: 'PUT',
          body: mergedata,
          headers: {
            'Content-type': 'application/json',
            'wcConfigId': 2017,
          }
        }
      },
    }),
    mapAcsforDistrict: builder.mutation({
      query: (data) => {
        const { ctId, bodydata,state } = data
        return {
          url: `/api/v1/controlTable/mapACsforDistrict?ctId=${ctId}`,
          method: 'POST',
          body: bodydata,
          headers: {
            'Content-type': 'application/json',
            'wcConfigId': 1009,
            'state':state
          }
        }
      },
    }),
    demapAcsforDistrict: builder.mutation({
      query: (data) => {
        const { ctId, bodydata,state } = data
        return {
          url: `/api/v1/controlTable/deMapACsForDistrict?ctId=${ctId}`,
          method: 'POST',
          body: bodydata,
          headers: {
            'Content-type': 'application/json',
            'wcConfigId': 1017,
            'state':state
          }
        }
      },
    }),
    mapAcsforPc: builder.mutation({
      query: (data) => {
        const { ctId, bodydata,state } = data
        return {
          url: `/api/v1/controlTable/mapACsforPc?ctId=${ctId}`,
          method: 'POST',
          body: bodydata,
          headers: {
            'Content-type': 'application/json',
            'wcConfigId': 2003,
            'state':state
          }
        }
      },
    }),
    demapAcsforPc: builder.mutation({
      query: (data) => {
        const { ctId, bodydata,state } = data
        return {
          url: `/api/v1/controlTable/deMapACsForPc?ctId=${ctId}`,
          method: 'POST',
          body: bodydata,
          headers: {
            'Content-type': 'application/json',
            'wcConfigId': 3017,
            'state':state
          }
        }
      },
    }),
    mapPartforAc: builder.mutation({
      query: (data) => {
        const { ctId, bodydata,state } = data
        return {
          url: `/api/v1/controlTable/mapPartsforAc?ctId=${ctId}`,
          method: 'POST',
          body: bodydata,
          headers: {
            'Content-type': 'application/json',
            'wcConfigId': 1009,
            'state':state
          }
        }
      },
    }),
    demapPartsforAc: builder.mutation({
      query: (data) => {
        const { ctId, bodydata,state } = data
        return {
          url: `/api/v1/controlTable/deMapPartsForAc?ctId=${ctId}`,
          method: 'POST',
          body: bodydata,
          headers: {
            'Content-type': 'application/json',
            'wcConfigId': 5025,
            'state':state
          }
        }
      },
    }),
   
   
    getEciStateList: builder.query({
      query: (data) => {
        return {
          url: `/api/v1/controlTable/list/getEciStateList`,
          method: 'GET',
          headers: {
            'Content-type': 'application/json; charset=UTF-8',
          },
        }
      }
    }),

    getEciPendingList: builder.query({
      query: (data) => {
        // const {acNo,districtCode,entityType,stateCode} = data
        return {
          url: `/api/v1/controlTable/list/getEciPendingListBasedOnStateDistrictAcEntityType?${data.stateCode!==""?"stateCode=":""}${data.stateCode!==""?data.stateCode:""}&${data.districtCode!==""?"districtCode=":""}${data.districtCode!==""?data.districtCode:""}&${data.acNo!==""?"acNo=":""}${data.acNo!==""?data.acNo:""}&${data.entityType!==""?"entityType=":""}${data.entityType!==""?data.entityType:""}`,
          method: 'GET',
          headers: {
            'Content-type': 'application/json; charset=UTF-8',
          },
          // params:{
          //   acNo:acNo,
          //   districtCode:districtCode,
          //   entityType:entityType,
          //   stateCode:stateCode
          // }
        }
      }
    }),

    getEciApprovalRejectionList: builder.query({
      query: (data) => {
        // const {acNo,districtCode,entityType,stateCode,status} = data
        return {
          url: `/api/v1/controlTable/list/getEciApprovalOrRejectionHistory?${data.stateCode!==""?"stateCode=":""}${data.stateCode!==""?data.stateCode:""}&${data.districtCode!==""?"districtCode=":""}${data.districtCode!==""?data.districtCode:""}&${data.acNo!==""?"acNo=":""}${data.acNo!==""?data.acNo:""}&${data.entityType!==""?"entityType=":""}${data.entityType!==""?data.entityType:""}&${data.status!==""?"status=":""}${data.status!==""?data.status:""}`,
          method: 'GET',
          headers: {
            'Content-type': 'application/json; charset=UTF-8',
          },
          // params:{
          //   acNo:acNo,
          //   districtCode:districtCode,
          //   entityType:entityType,
          //   stateCode:stateCode,
          //   status:status
          // }
        }
      }
    }),

    //approval apis

    approveBlockRequest: builder.mutation({
      query: (data) => {
        const { userRemarks,approvalStatus,bodydata,state } = data
        return {
          url: `/api/v1/controlTable/approveBlockRequestByECI`,
          method: 'POST',
          body: bodydata,
          headers: {
            'Authorization': 'Bearer ' + localStorage.access_token,
            'Content-type': 'application/json',
            'wcConfigId': 1104,
            'state':state
          },
          params:{
            approvalStatus:approvalStatus,
            userRemarks:userRemarks
          }
        }
      },
    }),
    rejectBlockRequest: builder.mutation({
      query: (data) => {
        const { approvalStatus, userRemarks,bodydata,state } = data
        return {
          url: `/api/v1/controlTable/rejectBlockRequest?approvalStatus=${approvalStatus}&userRemarks=${userRemarks}`,
          method: 'POST',
          body: bodydata,
          headers: {
            'Authorization': 'Bearer ' + localStorage.access_token,
            'Content-type': 'application/json',
            'wcConfigId': 1105,
            'state':state
          }
        }
      },
    }),
    approvePanchayatRequest: builder.mutation({
      query: (data) => {
        const { userRemarks,bodydata,approvalStatus,state } = data
        return {
          url: `/api/v1/controlTable/approvePanchayatRequestByECI?approvalStatus=${approvalStatus}&userRemarks=${userRemarks}`,
          method: 'POST',
          body: bodydata,
          headers: {
            'Authorization': 'Bearer ' + localStorage.access_token,
            'Content-type': 'application/json',
            'wcConfigId': 2104,
            'state':state
          }
        }
      },
    }),
    rejectPanchayatRequest: builder.mutation({
      query: (data) => {
        const { approvalStatus, userRemarks,bodydata,state } = data
        return {
          url: `/api/v1/controlTable/rejectPanchayatRequest?approvalStatus=${approvalStatus}&userRemarks=${userRemarks}`,
          method: 'POST',
          body: bodydata,
          headers: {
            'Authorization': 'Bearer ' + localStorage.access_token,
            'Content-type': 'application/json',
            'wcConfigId': 2105,
            'state':state
          }
        }
      },
    }),
    approvePatwariRequest: builder.mutation({
      query: (data) => {
        const { approvalStatus, userRemarks ,bodydata,state} = data
        return {
          url: `/api/v1/controlTable/approvePatwariRequestByECI?approvalStatus=${approvalStatus}&userRemarks=${userRemarks}`,
          method: 'POST',
          body: bodydata,
          headers: {
            'Authorization': 'Bearer ' + localStorage.access_token,
            'Content-type': 'application/json',
            'wcConfigId': 2204,
            'state':state
          }
        }
      },
    }),
    rejectPatwariRequest: builder.mutation({
      query: (data) => {
        const { approvalStatus, userRemarks,bodydata,state } = data
        return {
          url: `/api/v1/controlTable/rejectPatwariRequest?approvalStatus=${approvalStatus}&userRemarks=${userRemarks}`,
          method: 'POST',
          body: bodydata,
          headers: {
            'Authorization': 'Bearer ' + localStorage.access_token,
            'Content-type': 'application/json',
            'wcConfigId': 2205,
            'state':state
          }
        }
      },
    }),
    approveSubDivisionRequest: builder.mutation({
      query: (data) => {
        const { userRemarks,approvalStatus,bodydata,state } = data
        return {
          url: `/api/v1/controlTable/approveSubDivisionRequestByECI?approvalStatus=${approvalStatus}&userRemarks=${userRemarks}`,
          method: 'POST',
          body: bodydata,
          headers: {
            'Authorization': 'Bearer ' + localStorage.access_token,
            'Content-type': 'application/json',
            'wcConfigId': 8004,
            'state':state
          }
        }
      },
    }),
    rejectSubDivisionRequest: builder.mutation({
      query: (data) => {
        const { approvalStatus, userRemarks,bodydata,state } = data
        return {
          url: `api/v1/controlTable/rejectSubDivisionRequest?approvalStatus=${approvalStatus}&userRemarks=${userRemarks}`,
          method: 'POST',
          body: bodydata,
          headers: {
            'Authorization': 'Bearer ' + localStorage.access_token,
            'Content-type': 'application/json',
            'wcConfigId': 8005,
            'state':state
          }
        }
      },
    }),
    approveTehsilRequest: builder.mutation({
      query: (data) => {
        const { userRemarks,approvalStatus,bodydata,state } = data
        return {
          url: `/api/v1/controlTable/approveTehsilRequestByECI?approvalStatus=${approvalStatus}&userRemarks=${userRemarks}`,
          method: 'POST',
          body: bodydata,
          headers: {
            'Authorization': 'Bearer ' + localStorage.access_token,
            'Content-type': 'application/json',
            'wcConfigId': 9004,
            'state':state
          }
        }
      },
    }),
    rejectTehsilRequest: builder.mutation({
      query: (data) => {
        const { approvalStatus, userRemarks,bodydata,state } = data
        return {
          url: `/api/v1/controlTable/rejectTehsilRequest?approvalStatus=${approvalStatus}&userRemarks=${userRemarks}`,
          method: 'POST',
          body: bodydata,
          headers: {
            'Authorization': 'Bearer ' + localStorage.access_token,
            'Content-type': 'application/json',
            'wcConfigId': 9005,
            'state':state
          }
        }
      },
    }),
    approveTownRequest: builder.mutation({
      query: (data) => {
        const { approvalStatus, userRemarks,bodydata,state } = data
        return {
          url: `/api/v1/controlTable/approveTownRequestByECI?approvalStatus=${approvalStatus}&userRemarks=${userRemarks}`,
          method: 'POST',
          body: bodydata,
          headers: {
            'Authorization': 'Bearer ' + localStorage.access_token,
            'Content-type': 'application/json',
            'wcConfigId': 2304,
            'state':state
          }
        }
      },
    }),
    rejectTownRequest: builder.mutation({
      query: (data) => {
        const { approvalStatus, userRemarks,bodydata,state } = data
        return {
          url: `/api/v1/controlTable/rejectTownRequest?approvalStatus=${approvalStatus}&userRemarks=${userRemarks}`,
          method: 'POST',
          body: bodydata,
          headers: {
            'Authorization': 'Bearer ' + localStorage.access_token,
            'Content-type': 'application/json',
            'wcConfigId': 2305,
            'state':state
          }
        }
      },
    }),
    approveVillageRequest: builder.mutation({
      query: (data) => {
        const { approvalStatus,userRemarks,bodydata,state } = data
        return {
          url: `/api/v1/controlTable/approveVillageRequestByECI?approvalStatus=${approvalStatus}&userRemarks=${userRemarks}`,
          method: 'POST',
          body: bodydata,
          headers: {
            'Authorization': 'Bearer ' + localStorage.access_token,
            'Content-type': 'application/json',
            'wcConfigId': 2404,
            'state':state
          }
        }
      },
    }),
    rejectVillageRequest: builder.mutation({
      query: (data) => {
        const { approvalStatus, userRemarks,bodydata,state } = data
        return {
          url: `/api/v1/controlTable/rejectVillageRequest?approvalStatus=${approvalStatus}&userRemarks=${userRemarks}`,
          method: 'POST',
          body: bodydata,
          headers: {
            'Authorization': 'Bearer ' + localStorage.access_token,
            'Content-type': 'application/json',
            'wcConfigId': 2405,
            'state':state
          }
        }
      },
    }),
    approveKanoongoRequest: builder.mutation({
      query: (data) => {
        const { userRemarks,approvalStatus,bodydata,state } = data
        return {
          url: `/api/v1/controlTable/approveRisByECI?approvalStatus=${approvalStatus}&userRemarks=${userRemarks}`,
          method: 'POST',
          body: bodydata,
          headers: {
            'Authorization': 'Bearer ' + localStorage.access_token,
            'Content-type': 'application/json',
            'wcConfigId': 2604,
            'state':state
          }
        }
      },
    }),
    rejectKanoongoRequest: builder.mutation({
      query: (data) => {
        const { approvalStatus, userRemarks,bodydata,state } = data
        return {
          url: `/api/v1/controlTable/rejectNewRis?approvalStatus=${approvalStatus}&userRemarks=${userRemarks}`,
          method: 'POST',
          body: bodydata,
          headers: {
            'Authorization': 'Bearer ' + localStorage.access_token,
            'Content-type': 'application/json',
            'wcConfigId': 2605,
            'state':state
          }
        }
      },
    }),
    approvePoliceStationRequest: builder.mutation({
      query: (data) => {
        const { userRemarks,approvalStatus,bodydata,state } = data
        return {
          url: `/api/v1/controlTable/approvePoliceStationByECI?approvalStatus=${approvalStatus}&userRemarks=${userRemarks}`,
          method: 'POST',
          body: bodydata,
          headers: {
            'Authorization': 'Bearer ' + localStorage.access_token,
            'Content-type': 'application/json',
            'wcConfigId': 4004,
            'state':state
          }
        }
      },
    }),
    rejectPoliceStationRequest: builder.mutation({
      query: (data) => {
        const { approvalStatus, userRemarks,bodydata,state } = data
        return {
          url: `/api/v1/controlTable/rejectNewPoliceStation?approvalStatus=${approvalStatus}&userRemarks=${userRemarks}`,
          method: 'POST',
          body: bodydata,
          headers: {
            'Authorization': 'Bearer ' + localStorage.access_token,
            'Content-type': 'application/json',
            'wcConfigId': 4005,
            'state':state
          }
        }
      },
    }),
    approvePostOfficeRequest: builder.mutation({
      query: (data) => {
        const { userRemarks,approvalStatus,bodydata,state } = data
        return {
          url: `/api/v1/controlTable/approvePostOfficeByECI?approvalStatus=${approvalStatus}&userRemarks=${userRemarks}`,
          method: 'POST',
          body: bodydata,
          headers: {
            'Authorization': 'Bearer ' + localStorage.access_token,
            'Content-type': 'application/json',
            'wcConfigId': 1204,
            'state':state
          }
        }
      },
    }),
    rejectPostOfficeRequest: builder.mutation({
      query: (data) => {
        const { approvalStatus, userRemarks, bodydata,state } = data
        return {
          url: `/api/v1/controlTable/rejectNewPostOffice?approvalStatus=${approvalStatus}&userRemarks=${userRemarks}`,
          method: 'POST',
          body: bodydata,
          headers: {
            'Authorization': 'Bearer ' + localStorage.access_token,
            'Content-type': 'application/json',
            'wcConfigId': 1205,
            'state':state
          }
        }
      },
    }),
    approvePSBuildingRequest: builder.mutation({
      query: (data) => {
        const { approvalStatus,userRemarks,bodydata,state } = data
        return {
          url: `/api/v1/controlTable/approvePsBuildingByECI?approvalStatus=${approvalStatus}&userRemarks=${userRemarks}`,
          method: 'POST',
          body: bodydata,
          headers: {
            'Authorization': 'Bearer ' + localStorage.access_token,
            'Content-type': 'application/json',
            'wcConfigId': 2504,
            'state':state
          }
        }
      },
    }),
    rejectPSBuildingRequest: builder.mutation({
      query: (data) => {
        const { approvalStatus, userRemarks,bodydata,state } = data
        return {
          url: `/api/v1/controlTable/rejectNewPsBuilding?approvalStatus=${approvalStatus}&userRemarks=${userRemarks}`,
          method: 'POST',
          body: bodydata,
          headers: {
            'Authorization': 'Bearer ' + localStorage.access_token,
            'Content-type': 'application/json',
            'wcConfigId': 2505,
            'state':state
          }
        }
      },
    }),
    approveWardRequest: builder.mutation({
      query: (data) => {
        const { userRemarks,approvalStatus,bodydata,state } = data
        return {
          url: `/api/v1/controlTable/approveWardByECI?approvalStatus=${approvalStatus}&userRemarks=${userRemarks}`,
          method: 'POST',
          body: bodydata,
          headers: {
            'Authorization': 'Bearer ' + localStorage.access_token,
            'Content-type': 'application/json',
            'wcConfigId': 1304,
            'state':state
          }
        }
      },
    }),
    rejectWardRequest: builder.mutation({
      query: (data) => {
        const { approvalStatus, userRemarks,bodydata,state } = data
        return {
          url: `/api/v1/controlTable/rejectNewWard?approvalStatus=${approvalStatus}&userRemarks=${userRemarks}`,
          method: 'POST',
          body: bodydata,
          headers: {
            'Authorization': 'Bearer ' + localStorage.access_token,
            'Content-type': 'application/json',
            'wcConfigId': 1305,
            'state':state
          }
        }
      },
    }),
    approveSectionRequest: builder.mutation({
      query: (data) => {
        const { userRemarks,bodydata,approvalStatus,state } = data
        return {
          url: `/api/v1/controlTable/approveSectionRequestByECI?approvalStatus=${approvalStatus}&userRemarks=${userRemarks}`,
          method: 'POST',
          body: bodydata,
          headers: {
            'Authorization': 'Bearer ' + localStorage.access_token,
            'Content-type': 'application/json',
            'wcConfigId': 6004,
            'state':state
          }
        }
      },
    }),
    rejectSectionRequest: builder.mutation({
      query: (data) => {
        const { userRemarks,bodydata,approvalStatus,state } = data
        return {
          url: `/api/v1/controlTable/rejectSectionRequest?approvalStatus=${approvalStatus}&userRemarks=${userRemarks}`,
          method: 'POST',
          body: bodydata,
          headers: {
            'Authorization': 'Bearer ' + localStorage.access_token,
            'Content-type': 'application/json',
            'wcConfigId': 6005,
            'state':state
          }
        }
      },
    }),
    approveSplitSection:builder.mutation({
      query:(data) => {
        const { userRemarks,bodydata,approvalStatus,state } = data
        return {
          url: `/api/v1/controlTable/approveSplitSectionbyECI?approvalStatus=${approvalStatus}&userRemarks=${userRemarks}`,
          method: 'POST',
          body: bodydata,
          headers: {
            'Authorization': 'Bearer ' + localStorage.access_token,
            'Content-type': 'application/json',
            'wcConfigId': 6010,
            'state':state
          }
        }
      }
    }),
    rejectSplitSectionRequest: builder.mutation({
      query: (data) => {
        const { userRemarks,bodydata,approvalStatus,state } = data
        return {
          url: `/api/v1/controlTable/rejectSplitSectionRequest?approvalStatus=${approvalStatus}&userRemarks=${userRemarks}`,
          method: 'POST',
          body: bodydata,
          headers: {
            'Authorization': 'Bearer ' + localStorage.access_token,
            'Content-type': 'application/json',
            'wcConfigId': 6011,
            'state':state
          }
        }
      },
    }),
    approveMergeSectionRequest: builder.mutation({
      query: (data) => {
        const { userRemarks,bodydata,approvalStatus,state } = data
        return {
          url: `/api/v1/controlTable/approveMergeSectionRequestbyECI?approvalStatus=${approvalStatus}&userRemarks=${userRemarks}`,
          method: 'POST',
          body: bodydata,
          headers: {
            'Authorization': 'Bearer ' + localStorage.access_token,
            'Content-type': 'application/json',
            'wcConfigId': 6022,
            'state':state
          }
        }
      },
    }),
    rejectMergeSectionRequest: builder.mutation({
      query: (data) => {
        const { userRemarks,bodydata,approvalStatus,state } = data
        return {
          url: `/api/v1/controlTable/rejectMergeSectionRequest?approvalStatus=${approvalStatus}&userRemarks=${userRemarks}`,
          method: 'POST',
          body: bodydata,
          headers: {
            'Authorization': 'Bearer ' + localStorage.access_token,
            'Content-type': 'application/json',
            'wcConfigId': 6023,
            'state':state
          }
        }
      },
    }),
    approvePartRequest: builder.mutation({
      query: (data) => {
        const { userRemarks,bodydata,approvalStatus,state } = data
        return {
          url: `/api/v1/controlTable/approvePartRequestByECI?approvalStatus=${approvalStatus}&userRemarks=${userRemarks}`,
          method: 'POST',
          body: bodydata,
          headers: {
            'Authorization': 'Bearer ' + localStorage.access_token,
            'Content-type': 'application/json',
            'wcConfigId': 5004,
            'state':state
          }
        }
      },
    }),
    rejectPartRequest: builder.mutation({
      query: (data) => {
        const { userRemarks,bodydata,approvalStatus,state } = data
        return {
          url: `/api/v1/controlTable/rejectPartRequest?approvalStatus=${approvalStatus}&userRemarks=${userRemarks}`,
          method: 'POST',
          body: bodydata,
          headers: {
            'Authorization': 'Bearer ' + localStorage.access_token,
            'Content-type': 'application/json',
            'wcConfigId': 5005,
            'state':state
          }
        }
      },
    }),
    approveSplitPartRequest: builder.mutation({
      query: (data) => {
        const { userRemarks,bodydata,approvalStatus,state } = data
        return {
          url: `/api/v1/controlTable/approveSplitPartbyECI?approvalStatus=${approvalStatus}&userRemarks=${userRemarks}`,
          method: 'POST',
          body: bodydata,
          headers: {
            'Authorization': 'Bearer ' + localStorage.access_token,
            'Content-type': 'application/json',
            'wcConfigId': 5010,
            'state':state
          }
        }
      },
    }),
    rejectSplitPartRequest: builder.mutation({
      query: (data) => {
        const { userRemarks,bodydata,approvalStatus,state } = data
        return {
          url: `/api/v1/controlTable/rejectSplitPart?approvalStatus=${approvalStatus}&userRemarks=${userRemarks}`,
          method: 'POST',
          body: bodydata,
          headers: {
            'Authorization': 'Bearer ' + localStorage.access_token,
            'Content-type': 'application/json',
            'wcConfigId': 5011,
            'state':state
          }
        }
      },
    }),
    approveMergePartRequest: builder.mutation({
      query: (data) => {
        const { userRemarks,bodydata,approvalStatus,state } = data
        return {
          url: `/api/v1/controlTable/approveMergePartRequestbyECI?approvalStatus=${approvalStatus}&userRemarks=${userRemarks}`,
          method: 'POST',
          body: bodydata,
          headers: {
            'Authorization': 'Bearer ' + localStorage.access_token,
            'Content-type': 'application/json',
            'wcConfigId': 5022,
            'state':state
          }
        }
      },
    }),
    rejectMergePartRequest: builder.mutation({
      query: (data) => {
        const { userRemarks,bodydata,approvalStatus,state } = data
        return {
          url: `/api/v1/controlTable/rejectMergePartRequest?approvalStatus=${approvalStatus}&userRemarks=${userRemarks}`,
          method: 'POST',
          body: bodydata,
          headers: {
            'Authorization': 'Bearer ' + localStorage.access_token,
            'Content-type': 'application/json',
            'wcConfigId': 5023,
            'state':state
          }
        }
      },
    }),
    approveAcRequest:builder.mutation({
      query:(data) => {
        const { userRemarks,bodydata,approvalStatus,state } = data
        return {
          url: `/api/v1/controlTable/approveAcRequest?approvalStatus=${approvalStatus}&userRemarks=${userRemarks}`,
          method: 'POST',
          body: bodydata,
          headers: {
            'Authorization': 'Bearer ' + localStorage.access_token,
            'Content-type': 'application/json',
            'wcConfigId': 1002,
            'state':state
          }
        }
      }
    }),
    rejectAcRequest:builder.mutation({
      query:(data) => {
        const { userRemarks,bodydata,approvalStatus,state } = data
        return {
          url: `/api/v1/controlTable/rejectAcRequest?approvalStatus=${approvalStatus}&userRemarks=${userRemarks}`,
          method: 'POST',
          body: bodydata,
          headers: {
            'Authorization': 'Bearer ' + localStorage.access_token,
            'Content-type': 'application/json',
            'wcConfigId': 1003,
            'state':state
          }
        }
      }
    }),
    approveDeMapPartsForAcRequest:builder.mutation({
      query:(data) => {
        const { userRemarks,bodydata,approvalStatus,state } = data
        return {
          url: `/api/v1/controlTable/approveDeMapPartsforAcRequest?approvalStatus=${approvalStatus}&userRemarks=${userRemarks}`,
          method: 'POST',
          body: bodydata,
          headers: {
            'Content-type': 'application/json',
            'wcConfigId': 5028,
            'state':state
          }
        }
      }
    }),
    rejectDeMapPartsForAcRequest:builder.mutation({
      query:(data) => {
        const { userRemarks,bodydata,approvalStatus,state } = data
        return {
          url: `/api/v1/controlTable/rejectDeMapPartsforAcRequest?approvalStatus=${approvalStatus}&userRemarks=${userRemarks}`,
          method: 'POST',
          body: bodydata,
          headers: {
            'Content-type': 'application/json',
            'wcConfigId': 5029,
            'state':state
          }
        }
      }
    }),
    approveMapPartsForAcRequest:builder.mutation({
      query:(data) => {
        const { userRemarks,bodydata,approvalStatus,state } = data
        return {
          url: `/api/v1/controlTable/approveMapPartsforAcRequest?approvalStatus=${approvalStatus}&userRemarks=${userRemarks}`,
          method: 'POST',
          body: bodydata,
          headers: {
            'Content-type': 'application/json',
            'wcConfigId': 5016,
            'state':state
          }
        }
      }
    }),
    rejectMapPartsForAcRequest:builder.mutation({
      query:(data) => {
        const { userRemarks,bodydata,approvalStatus,state } = data
        return {
          url: `/api/v1/controlTable/rejectMapPartsforAcRequest?approvalStatus=${approvalStatus}&userRemarks=${userRemarks}`,
          method: 'POST',
          body: bodydata,
          headers: {
            'Content-type': 'application/json',
            'wcConfigId': 5017,
            'state':state
          }
        }
      }
    }),
    approveMergeAc:builder.mutation({
      query:(data) => {
        const { userRemarks,bodydata,approvalStatus,state } = data
        return {
          url: `/api/v1/controlTable/approveMergeAcRequest?approvalStatus=${approvalStatus}&userRemarks=${userRemarks}`,
          method: 'POST',
          body: bodydata,
          headers: {
            'Authorization': 'Bearer ' + localStorage.access_token,
            'Content-type': 'application/json',
            'wcConfigId': 1014,
            'state':state
          }
        }
      }
    }),
    rejectMergeAc:builder.mutation({
      query:(data) => {
        const { userRemarks,bodydata,approvalStatus,state } = data
        return {
          url: `/api/v1/controlTable/rejectMergeAcRequest?approvalStatus=${approvalStatus}&userRemarks=${userRemarks}`,
          method: 'POST',
          body: bodydata,
          headers: {
            'Authorization': 'Bearer ' + localStorage.access_token,
            'Content-type': 'application/json',
            'wcConfigId': 1015,
            'state':state
          }
        }
      }
    }),
    approveSplitAc:builder.mutation({
      query:(data) => {
        const { userRemarks,bodydata,approvalStatus,state } = data
        return {
          url: `/api/v1/controlTable/approveSplitAcRequest?approvalStatus=${approvalStatus}&userRemarks=${userRemarks}`,
          method: 'POST',
          body: bodydata,
          headers: {
            'Authorization': 'Bearer ' + localStorage.access_token,
            'Content-type': 'application/json',
            'wcConfigId': 1006,
            'state':state
          }
        }
      }
    }),
    rejectSplitAc:builder.mutation({
      query:(data) => {
        const { userRemarks,bodydata,approvalStatus,state } = data
        return {
          url: `/api/v1/controlTable/rejectSplitAcRequest?approvalStatus=${approvalStatus}&userRemarks=${userRemarks}`,
          method: 'POST',
          body: bodydata,
          headers: {
            'Authorization': 'Bearer ' + localStorage.access_token,
            'Content-type': 'application/json',
            'wcConfigId': 1007,
            'state':state
          }
        }
      }
    }),
    approvePc:builder.mutation({
      query:(data) => {
        const { userRemarks,bodydata,approvalStatus,state } = data
        return {
          url: `/api/v1/controlTable/approvePcRequestByEci?approvalStatus=${approvalStatus}&userRemarks=${userRemarks}`,
          method: 'POST',
          body: bodydata,
          headers: {
            'Authorization': 'Bearer ' + localStorage.access_token,
            'Content-type': 'application/json',
            'wcConfigId': 3002,
            'state':state
          }
        }
      }
    }),
    rejectPc:builder.mutation({
      query:(data) => {
        const { userRemarks,bodydata,approvalStatus,state } = data
        return {
          url: `/api/v1/controlTable/rejectPcRequestByEci?approvalStatus=${approvalStatus}&userRemarks=${userRemarks}`,
          method: 'POST',
          body: bodydata,
          headers: {
            'Authorization': 'Bearer ' + localStorage.access_token,
            'Content-type': 'application/json',
            'wcConfigId': 3003,
            'state':state
          }
        }
      }
    }),
    approveMergePc:builder.mutation({
      query:(data) => {
        const { userRemarks,bodydata,approvalStatus,state } = data
        return {
          url: `/api/v1/controlTable/approveMergePcRequest?approvalStatus=${approvalStatus}&userRemarks=${userRemarks}`,
          method: 'POST',
          body: bodydata,
          headers: {
            'Authorization': 'Bearer ' + localStorage.access_token,
            'Content-type': 'application/json',
            'wcConfigId': 3014,
            'state':state
          }
        }
      }
    }),
    rejectMergePc:builder.mutation({
      query:(data) => {
        const { userRemarks,bodydata,approvalStatus,state } = data
        return {
          url: `/api/v1/controlTable/rejectMergePcRequest?approvalStatus=${approvalStatus}&userRemarks=${userRemarks}`,
          method: 'POST',
          body: bodydata,
          headers: {
            'Authorization': 'Bearer ' + localStorage.access_token,
            'Content-type': 'application/json',
            'wcConfigId': 3015,
            'state':state
          }
        }
      }
    }),
    approveSplitPc:builder.mutation({
      query:(data) => {
        const { userRemarks,bodydata,approvalStatus,state } = data
        return {
          url: `/api/v1/controlTable/approveSplitPcRequest?approvalStatus=${approvalStatus}&userRemarks=${userRemarks}`,
          method: 'POST',
          body: bodydata,
          headers: {
            'Authorization': 'Bearer ' + localStorage.access_token,
            'Content-type': 'application/json',
            'wcConfigId': 3006,
            'state':state
          }
        }
      }
    }),
    rejectSplitPc:builder.mutation({
      query:(data) => {
        const { userRemarks,bodydata,approvalStatus,state } = data
        return {
          url: `/api/v1/controlTable/rejectSplitPcRequest?approvalStatus=${approvalStatus}&userRemarks=${userRemarks}`,
          method: 'POST',
          body: bodydata,
          headers: {
            'Authorization': 'Bearer ' + localStorage.access_token,
            'Content-type': 'application/json',
            'wcConfigId': 3007,
            'state':state
          }
        }
      }
    }),
    approveDistrict:builder.mutation({
      query:(data) => {
        const { userRemarks,bodydata,approvalStatus,state } = data
        return {
          url: `/api/v1/controlTable/approveNewDistrict?approvalStatus=${approvalStatus}&userRemarks=${userRemarks}`,
          method: 'POST',
          body: bodydata,
          headers: {
            'Authorization': 'Bearer ' + localStorage.access_token,
            'Content-type': 'application/json',
            'wcConfigId': 2002,
            'state':state
          }
        }
      }
    }),
    rejectDistrict:builder.mutation({
      query:(data) => {
        const { userRemarks,bodydata,approvalStatus,state } = data
        return {
          url: `/api/v1/controlTable/rejectNewDistrictByECI?approvalStatus=${approvalStatus}&userRemarks=${userRemarks}`,
          method: 'POST',
          body: bodydata,
          headers: {
            'Authorization': 'Bearer ' + localStorage.access_token,
            'Content-type': 'application/json',
            'wcConfigId': 2003,
            'state':state
          }
        }
      }
    }),
    approveMergeDistrict:builder.mutation({
      query:(data) => {
        const { userRemarks,bodydata,approvalStatus,state } = data
        return {
          url: `/api/v1/controlTable/approveMergeDistrictRequest?approvalStatus=${approvalStatus}&userRemarks=${userRemarks}`,
          method: 'POST',
          body: bodydata,
          headers: {
            'Authorization': 'Bearer ' + localStorage.access_token,
            'Content-type': 'application/json',
            'wcConfigId': 2014,
            'state':state
          }
        }
      }
    }),
    rejectMergeDistrict:builder.mutation({
      query:(data) => {
        const { userRemarks,bodydata,approvalStatus,state } = data
        return {
          url: `/api/v1/controlTable/rejectMergeDistrictRequest?approvalStatus=${approvalStatus}&userRemarks=${userRemarks}`,
          method: 'POST',
          body: bodydata,
          headers: {
            'Authorization': 'Bearer ' + localStorage.access_token,
            'Content-type': 'application/json',
            'wcConfigId': 2015,
            'state':state
          }
        }
      }
    }),
    approveSplitDistrict:builder.mutation({
      query:(data) => {
        const { userRemarks,bodydata,approvalStatus,state } = data
        return {
          url: `/api/v1/controlTable/approveSplitDistrictRequest?approval=${approvalStatus}&userRemarks=${userRemarks}`,
          method: 'POST',
          body: bodydata,
          headers: {
            'Authorization': 'Bearer ' + localStorage.access_token,
            'Content-type': 'application/json',
            'wcConfigId': 2006,
            'state':state
          }
        }
      }
    }),
    rejectSplitDistrict:builder.mutation({
      query:(data) => {
        const { userRemarks,bodydata,approvalStatus,state } = data
        return {
          url: `/api/v1/controlTable/rejectSplitDistrictRequest?approval=${approvalStatus}&userRemarks=${userRemarks}`,
          method: 'POST',
          body: bodydata,
          headers: {
            'Authorization': 'Bearer ' + localStorage.access_token,
            'Content-type': 'application/json',
            'wcConfigId': 2007,
            'state':state
          }
        }
      }
    }),
    approveDeMapAcforDistrict:builder.mutation({
      query:(data) => {
        const { userRemarks,bodydata,approvalStatus,state } = data
        return {
          url: `/api/v1/controlTable/approveDeMapAcforDistrict?approvalStatus=${approvalStatus}&userRemarks=${userRemarks}`,
          method: 'POST',
          body: bodydata,
          headers: {
            'Content-type': 'application/json',
            'wcConfigId': 2006,
            'state':state
          }
        }
      }
    }),
    rejectDeMapAcforDistrict:builder.mutation({
      query:(data) => {
        const { userRemarks,bodydata,approvalStatus,state } = data
        return {
          url: `/api/v1/controlTable/rejectDeMapAcforDistrict?approvalStatus=${approvalStatus}&userRemarks=${userRemarks}`,
          method: 'POST',
          body: bodydata,
          headers: {
            'Content-type': 'application/json',
            'wcConfigId': 2006,
            'state':state
          }
        }
      }
    }),
    approveAuxPart:builder.mutation({
      query:(data) => {
        const { userRemarks,bodydata,approvalStatus,state } = data
        return {
          url: `/api/v1/controlTable/approveAuxPsRequestByECI?approvalStatus=${approvalStatus}&userRemarks=${userRemarks}`,
          method: 'POST',
          body: bodydata,
          headers: {
            'Authorization': 'Bearer ' + localStorage.access_token,
            'Content-type': 'application/json',
            'wcConfigId': 2804,
            'state':state
          }
        }
      }
    }),
    rejectAuxPart:builder.mutation({
      query:(data) => {
        const { userRemarks,bodydata,approvalStatus,state } = data
        return {
          url: `/api/v1/controlTable/rejectAuxPsRequest?approvalStatus=${approvalStatus}&userRemarks=${userRemarks}`,
          method: 'POST',
          body: bodydata,
          headers: {
            'Authorization': 'Bearer ' + localStorage.access_token,
            'Content-type': 'application/json',
            'wcConfigId': 2805,
            'state':state
          }
        }
      }
    }),

  })
})

export const { useGetAllStatesQuery, useGetAcbasedonStatecodeQuery, useGetDistrictbasedonStatecodeQuery, useCreatenewstateMutation, useGetPartbasedonAcNoQuery,
  useGetPCbasedonStateCodeQuery, useGetAcbasedonPcNoQuery, useGetAcbasedonDistrictCodeQuery,
  useMapDistrictsForStateMutation, useSplitStateMutation, useDemapDistrictsForStateMutation, useMergeStateMutation, useEditDistrictMutation,
  useApproveBlockRequestMutation, useRejectBlockRequestMutation, useApprovePanchayatRequestMutation, useRejectPanchayatRequestMutation,
  useApprovePatwariRequestMutation, useRejectPatwariRequestMutation, useApproveSubDivisionRequestMutation, useRejectSubDivisionRequestMutation,
  useApproveTehsilRequestMutation, useRejectTehsilRequestMutation, useApproveTownRequestMutation, useRejectTownRequestMutation,
  useApproveVillageRequestMutation, useRejectVillageRequestMutation, useApproveKanoongoRequestMutation, useRejectKanoongoRequestMutation,
  useApprovePoliceStationRequestMutation, useRejectPoliceStationRequestMutation, useApprovePostOfficeRequestMutation, useRejectPostOfficeRequestMutation,
  useApprovePSBuildingRequestMutation, useRejectPSBuildingRequestMutation, useApproveWardRequestMutation, useRejectWardRequestMutation,
  useApproveSectionRequestMutation,useApproveMergeSectionRequestMutation,useApproveSplitPartRequestMutation,useApproveMergePartRequestMutation,
  useGetStateCodeQuery,useRejectSectionRequestMutation,useRejectMergeSectionRequestMutation,useRejectSplitPartRequestMutation,useRejectMergePartRequestMutation,
  useApproveAcRequestMutation,useApproveDeMapPartsForAcRequestMutation,useApproveMapPartsForAcRequestMutation,useApproveMergeAcMutation,useApproveSplitAcMutation,
  useRejectAcRequestMutation,useRejectDeMapPartsForAcRequestMutation,useRejectMapPartsForAcRequestMutation,useRejectMergeAcMutation,useRejectSplitAcMutation,
  useApprovePcMutation,useApproveMergePcMutation,useApproveSplitPcMutation,useRejectPcMutation,useRejectMergePcMutation,useRejectSplitPcMutation,
  useApproveDistrictMutation,useApproveMergeDistrictMutation,useApproveSplitDistrictMutation,useApproveDeMapAcforDistrictMutation,
  useRejectDistrictMutation,useRejectMergeDistrictMutation,useRejectSplitDistrictMutation,useRejectDeMapAcforDistrictMutation,
  useGetEciPendingListQuery,useGetEciApprovalRejectionListQuery,useGetEciStateListQuery,useApproveAuxPartMutation,useRejectAuxPartMutation,
  useMapAcsforDistrictMutation,useDemapAcsforDistrictMutation,useDemapAcsforPcMutation,useMapAcsforPcMutation,useDemapPartsforAcMutation,useMapPartforAcMutation,
  useApprovePartRequestMutation,useApproveSplitSectionMutation,useRejectPartRequestMutation,useRejectSplitSectionRequestMutation} = newstateApi;